import FakeBackendService from "@/app/http/services/fakeBackendService";

const fakeBackendService = new FakeBackendService();

export { fakeBackendService };
